import React from 'react';
import Drawer from '@mui/material/Drawer';
import { IconChevronLeft } from '@tabler/icons-react';
import TripItineraryContent from './TripItineraryContent';

interface TripItineraryDrawerProps {
  open: boolean;
  onClose: () => void;
  tripId: number;
}

const TripItineraryDrawer: React.FC<TripItineraryDrawerProps> = ({
  open,
  onClose,
  tripId,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{ paper: { sx: { width: '100%' } } }}
    >
      <div className="flex flex-col h-full">
        <div className="flex-grow overflow-y-auto p-6">
          <button
            type="button"
            className="flex items-center gap-2"
            onClick={onClose}
            aria-label="Back to trip details"
          >
            <IconChevronLeft size={24} />
          </button>
          <div className="mt-6">
            <TripItineraryContent tripId={tripId} enabled={open} />
          </div>
          <div className="pb-24" />
        </div>
        <div className="w-full flex items-center justify-end h-[77px] bg-neutral-00 border-t border-neutral-200">
          <button
            type="button"
            className="border py-3 px-6 h-[45px] mr-6 border-neutral-800 rounded-lg text-neutral-800 font-semibold"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default TripItineraryDrawer;
